import { render, staticRenderFns } from "./internshipresultsview.vue?vue&type=template&id=e83cc508&scoped=true&"
import script from "./internshipresultsview.vue?vue&type=script&lang=js&"
export * from "./internshipresultsview.vue?vue&type=script&lang=js&"
import style0 from "./internshipresultsview.vue?vue&type=style&index=0&id=e83cc508&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83cc508",
  null
  
)

export default component.exports